export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const PASSWORD_REGEX =
  /^(?=.*[0-9])(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/-]).{8,}$/

export const truncateMiddle = (string: string, maxLength = 40) => {
  const length = string.length

  if (length < maxLength) return string

  const charsToRemove = (maxLength - 3) / 2

  return `${string.substring(0, charsToRemove)}...${string.substring(
    length - charsToRemove
  )}`
}

export const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.substring(1).toLowerCase()
